export const UnitLabels: Record<string, string> = {
  area: 'Has',
  temperature: '°C',
  humidity: '%',
  rain: 'mm',
  performance: 'ton/ha'
};

export type UnitType = keyof typeof UnitLabels;

export const Units: { [K in UnitType]: K } = {
  area: 'area',
  ndvi: 'ndvi',
  temperature: 'temperature',
  humidity: 'humidity',
  rain: 'rain',
  performance: 'performance'
  
  
} as const;

